import React from "react";
import PropTypes from "prop-types";
import Button from "~/assets/js/components/Button";
import i18n from "~/assets/js/Helpers/i18n";
import { CheckCircle } from "react-feather";
import Headline from "~/assets/js/components/Typography/Headline";

const Success = ({ onContinueClick }) => {
    return (
        <div id="register-success">
            <CheckCircle size={48} scale={2} strokeWidth={1} />
            <Headline size={5} resizable>
                {i18n.t("register.success.title")}
            </Headline>
            <p>{i18n.t("register.success.text")}</p>
            <Button
                size="SM"
                label={i18n.t("register.success.continue")}
                onClick={onContinueClick}
            />
        </div>
    );
};

Success.propTypes = {
    onContinueClick: PropTypes.func.isRequired,
};

export default Success;
